export const coachHouseCellphone = '12053778385';
export const coachHouseContactPhone = '9782196788';
export const coachHouseEmail = 'reservations@coachhousesalem.com';
export const coachHouseFacebookLink = 'https://www.facebook.com/CoachHouseSalem';
export const coachHouseInstagramLink = 'https://www.instagram.com/coachhousesalem/';
export const coachHouseTiktokLink = 'https://www.tiktok.com/@coachhousesalem';
export const ourStoryContent = 'Not configured';
export const termsContent = 'Not configured';
export const agreementContent = 'Not configured';
export const bannerURL = '/room.png';
export const monthList = [
  'January',
  'February',
  'March',
  'April',
  'May',
  'June',
  'July',
  'August',
  'September',
  'October',
  'November',
  'December',
];

export const MessageDeliveryStatus: Record<string, string[]> = {
  SENT: ['sent', 'submitted'],
  DELIVERED: ['delivered'],
  REJECTED: ['rejected', 'undeliverable', 'undelivered', 'failed', 'canceled'],
  READ: ['read'],
  RECEIVED: ['received'],
  CLOCK: ['queued'],
  SCHEDULED: ['scheduled'],
};

export const unknownErrorMessage = 'Unknown Error';
const currentYear = new Date().getFullYear();
const range = (start: number, stop: number, step: number) =>
  Array.from({ length: (stop - start) / step + 1 }, (_, i) => start + i * step);
export const yearList = range(currentYear, currentYear - 20, -1);
